import { useQuery } from '@tanstack/react-query';
import { getIssuesGridData } from '../services/IIMIssuesService';
import { iimReviewKeys } from './queryKeys';
/**
 * Bucket/type counts for the AI summary banner (a one-row issues-grid fetch).
 */
export function useIssueBucketCounts(inspectionId) {
    return useQuery({
        queryKey: iimReviewKeys.bucketCounts(inspectionId),
        queryFn: () => getIssuesGridData({ inspectionId, page: 1, pageSize: 1 }),
        staleTime: 5 * 60 * 1000,
        select: (response) => ({
            bucketCounts: response.bucketCounts,
            typeCounts: response.typeCounts,
            primaryTechnician: response.primaryTechnician,
            assetCountChangeDetail: response.assetCountChangeDetail
        })
    });
}
